/**
 * @generated SignedSource<<84b5cec36358517f031ac3e5bb7d0219>>
 * @relayHash 66d191a5cf4d158b1d095665d91c4624
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 803ac5f4f755934617bd8141a7b5076bee417b0a28ce3ac9ea08f2f5e07bebe4

import type { ConcreteRequest } from 'relay-runtime';
export type ConvoAiSkillSource = "ANTHROPIC" | "STRATUS" | "%future added value";
export type autoSuggestSkills_AvailableSkillsQuery$variables = {
  after?: string | null;
  cloudId: string;
  first?: number | null;
  searchKeyword?: string | null;
  shouldFetch?: boolean | null;
};
export type autoSuggestSkills_AvailableSkillsQuery$data = {
  readonly convoai_availableSkills?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly __typename: "ConvoAiSkill";
        readonly category: string | null;
        readonly color: string | null;
        readonly description: string | null;
        readonly displayName: string | null;
        readonly helpText: string | null;
        readonly iconKey: string | null;
        readonly iconUrl: string | null;
        readonly id: string;
        readonly integrationKeys: ReadonlyArray<string>;
        readonly integrations: ReadonlyArray<{
          readonly displayName: string | null;
          readonly iconUrl: string | null;
          readonly id: string | null;
          readonly key: string;
        }>;
        readonly name: string;
        readonly slashCommand: string | null;
        readonly source: ConvoAiSkillSource;
        readonly tags: ReadonlyArray<string>;
        readonly version: string | null;
      } | null;
    }> | null;
    readonly errors: ReadonlyArray<{
      readonly message: string | null;
    }> | null;
    readonly metadata: {
      readonly anthropicCount: number;
      readonly isDegraded: boolean;
      readonly stratusCount: number;
    };
    readonly pageInfo: {
      readonly endCursor: string | null;
      readonly hasNextPage: boolean;
      readonly hasPreviousPage: boolean;
      readonly startCursor: string | null;
    };
    readonly totalCount: number;
  } | null;
};
export type autoSuggestSkills_AvailableSkillsQuery = {
  response: autoSuggestSkills_AvailableSkillsQuery$data;
  variables: autoSuggestSkills_AvailableSkillsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchKeyword"
},
v4 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "shouldFetch"
},
v5 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v6 = {
  "kind": "Variable",
  "name": "searchKeyword",
  "variableName": "searchKeyword"
},
v7 = {
  "kind": "ScalarField",
  "name": "id"
},
v8 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v9 = {
  "kind": "ScalarField",
  "name": "iconUrl"
},
v10 = [
  {
    "concreteType": "ConvoAiSkillEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "concreteType": "ConvoAiSkill",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "__typename"
          },
          (v7/*: any*/),
          {
            "kind": "ScalarField",
            "name": "name"
          },
          {
            "kind": "ScalarField",
            "name": "description"
          },
          (v8/*: any*/),
          {
            "kind": "ScalarField",
            "name": "slashCommand"
          },
          (v9/*: any*/),
          {
            "kind": "ScalarField",
            "name": "iconKey"
          },
          {
            "kind": "ScalarField",
            "name": "helpText"
          },
          {
            "kind": "ScalarField",
            "name": "color"
          },
          {
            "kind": "ScalarField",
            "name": "source"
          },
          {
            "kind": "ScalarField",
            "name": "tags"
          },
          {
            "kind": "ScalarField",
            "name": "category"
          },
          {
            "kind": "ScalarField",
            "name": "integrationKeys"
          },
          {
            "concreteType": "ConvoAiSkillIntegration",
            "kind": "LinkedField",
            "name": "integrations",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "key"
              },
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/)
            ]
          },
          {
            "kind": "ScalarField",
            "name": "version"
          }
        ]
      },
      {
        "kind": "ScalarField",
        "name": "cursor"
      }
    ]
  },
  {
    "concreteType": "PageInfo",
    "kind": "LinkedField",
    "name": "pageInfo",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "hasNextPage"
      },
      {
        "kind": "ScalarField",
        "name": "hasPreviousPage"
      },
      {
        "kind": "ScalarField",
        "name": "startCursor"
      },
      {
        "kind": "ScalarField",
        "name": "endCursor"
      }
    ]
  },
  {
    "kind": "ScalarField",
    "name": "totalCount"
  },
  {
    "concreteType": "ConvoAiSkillListMetadata",
    "kind": "LinkedField",
    "name": "metadata",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "anthropicCount"
      },
      {
        "kind": "ScalarField",
        "name": "stratusCount"
      },
      {
        "kind": "ScalarField",
        "name": "isDegraded"
      }
    ]
  },
  {
    "concreteType": "QueryError",
    "kind": "LinkedField",
    "name": "errors",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "message"
      }
    ]
  }
],
v11 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  (v5/*: any*/),
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  (v6/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "autoSuggestSkills_AvailableSkillsQuery",
    "selections": [
      {
        "condition": "shouldFetch",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "convoai_availableSkills",
            "args": [
              (v5/*: any*/),
              (v6/*: any*/)
            ],
            "concreteType": "ConvoAiAvailableSkillsResult",
            "kind": "LinkedField",
            "name": "__AutoSuggestSkills__convoai_availableSkills_connection",
            "plural": false,
            "selections": (v10/*: any*/)
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "autoSuggestSkills_AvailableSkillsQuery",
    "selections": [
      {
        "condition": "shouldFetch",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v11/*: any*/),
            "concreteType": "ConvoAiAvailableSkillsResult",
            "kind": "LinkedField",
            "name": "convoai_availableSkills",
            "plural": false,
            "selections": (v10/*: any*/)
          },
          {
            "args": (v11/*: any*/),
            "filters": [
              "cloudId",
              "searchKeyword"
            ],
            "handle": "connection",
            "key": "AutoSuggestSkills__convoai_availableSkills",
            "kind": "LinkedHandle",
            "name": "convoai_availableSkills"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "803ac5f4f755934617bd8141a7b5076bee417b0a28ce3ac9ea08f2f5e07bebe4",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": [
            "convoai_availableSkills"
          ]
        }
      ]
    },
    "name": "autoSuggestSkills_AvailableSkillsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "7be476b3761df5f61da30000c9ce27d1";

export default node;
